import { formatCurrency } from '../utilities/_commerce'

export const addToCartPackage = ({ title, url, preselectVariantId, variantsData }) => ({
	title,
	url,
	preselectVariantId,
	variants: variantsData,
	qty: 1,
	price: 0,
	onSale: false,
	salePrice: 0,
	selectedPackageName: null,
	selectedVariant: null,

	init() {
		const currentUrl = new URL(window.location.href)

		if (this.preselectVariantId) {
			const preselectedVariant = this.variants.find(variant => variant.id === this.preselectVariantId)

			// If the preselected variant we try to find a variant and preselect it's values.
			// If the URL param doesn't match a variant, clear the param and reload to prevent JS errors.
			// This can happen if a user shares a link with an invalid or removed variant ID.
			//
			if (preselectedVariant) {
				this.selectedPackageName = preselectedVariant.title || null
				this.updateSelectedVariant(true)
			} else {
				currentUrl.searchParams.delete('variant')
				window.history.replaceState({}, '', currentUrl)
				window.location.reload()
			}
		} else {
			this.initSelections()
		}

		this.$watch('selectedVariant', () => {
			if (this.selectedVariant?.id) {
				currentUrl.searchParams.set('variant', this.selectedVariant.id)
			} else {
				currentUrl.searchParams.delete('variant')
			}
			window.history.replaceState({}, '', currentUrl)
		})
	},

	get packageNames() {
		if (!this.variants) return []

		const seen = new Set()

		return this.variants
			.map(variant => variant.title)
			.filter(packageName => {
				if (!packageName) return false
				if (seen.has(packageName)) return false
				seen.add(packageName)
				return true
			})
	},

	initSelections() {
		if (!this.variants?.length) {
			this.selectedVariant = null
			return
		}

		const firstVariant = this.variants[0]
		this.selectedPackageName = firstVariant.title || null

		this.mapToAvailableVariant()
		this.updateSelectedVariant(true)
	},

	mapToAvailableVariant() {
		if (!this.variants?.length) {
			this.selectedVariant = null
			return
		}

		let variant = this.findVariantFor(this.selectedPackageName)

		if (!variant) {
			variant = this.variants[0]
		}

		if (!variant) {
			this.selectedVariant = null
			return
		}

		this.selectedPackageName = variant.title || null
	},

	selectPackageName(packageName) {
		this.selectedPackageName = packageName

		this.mapToAvailableVariant()
		this.updateSelectedVariant()
	},

	findVariantFor(packageName) {
		if (!this.variants) return null

		return this.variants.find(variant => {
			if (packageName && variant.title !== packageName) return false
			return true
		}) || null
	},

	findVariant() {
		if (!this.variants) return null

		return this.variants.find(variant => {
			if (this.selectedPackageName && variant.title !== this.selectedPackageName) return false
			return true
		}) || null
	},

	updateSelectedVariant(init = false) {
		this.selectedVariant = this.findVariant()

		if (!this.selectedVariant) return

		this.price = this.selectedVariant.price
		this.onSale = this.selectedVariant.isOnPromotion
		this.salePrice = this.selectedVariant.salePrice

		if (init) {
			setTimeout(() => {
				window.dispatchEvent(new CustomEvent('variantUpdated', {
					detail: {
						id: this.selectedVariant.id,
					}
				}))
			}, 1000)
		} else {
			window.dispatchEvent(new CustomEvent('variantUpdated', {
				detail: {
					id: this.selectedVariant.id,
				}
			}))
		}
	},

	qtyDown() {
		if (this.qty > 1) {
			this.qty--
		}
	},

	qtyUp() {
		this.qty++
	},

	getPrice(singular = false) {
		if (this.onSale) {
			if (singular) {
				return formatCurrency(this.salePrice)
			}
			return formatCurrency(this.salePrice * this.qty)
		}

		if (singular) {
			return formatCurrency(this.price)
		}
		return formatCurrency(this.price * this.qty)
	},

	getLineItemPrice(price) {
		return formatCurrency(price)
	},

	getOriginalPrice() {
		return formatCurrency(this.price * this.qty)
	},

	get variantOptionsString() {
		const options = []

		if (this.selectedPackageName) {
			options.push(this.selectedPackageName)
		}

		return options.join(', ')
	},

	async add() {
		if (!this.selectedVariant) return

		this.$store.cart.add(
			this.selectedVariant.id,
			this.title,
			this.onSale ? this.selectedVariant.salePrice : this.selectedVariant.price,
			this.qty,
			this.url + (this.selectedVariant ? `?variant=${this.selectedVariant.id}` : ''),
			this.variantOptionsString,
		)

		setTimeout(() => {
			this.$store.cart.getCart()
		}, 500)
	},
})
